"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StripeInput;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

function StripeInput(_ref) {
  var Component = _ref.component,
      inputRef = _ref.inputRef,
      ariaInvalid = _ref['aria-invalid'],
      ariaDescribeBy = _ref['aria-describedby'],
      defaultValue = _ref.defaultValue,
      required = _ref.required,
      onKeyDown = _ref.onKeyDown,
      onKeyUp = _ref.onKeyUp,
      readOnly = _ref.readOnly,
      autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      type = _ref.type,
      name = _ref.name,
      rows = _ref.rows,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["component", "inputRef", "aria-invalid", "aria-describedby", "defaultValue", "required", "onKeyDown", "onKeyUp", "readOnly", "autoComplete", "autoFocus", "type", "name", "rows"]);
  var theme = (0, _styles.useTheme)();

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      mountNode = _React$useState2[0],
      setMountNode = _React$useState2[1];

  (0, _react.useImperativeHandle)(inputRef, function () {
    return {
      focus: function focus() {
        return mountNode.focus();
      }
    };
  }, [mountNode]);
  return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
    onReady: setMountNode,
    style: {
      base: {
        color: theme.palette.text.primary,
        fontSize: "".concat(theme.typography.fontSize, "px"),
        fontFamily: theme.typography.fontFamily,
        '::placeholder': {
          color: (0, _styles.fade)(theme.palette.text.primary, 0.42)
        }
      },
      invalid: {
        color: theme.palette.text.primary
      }
    }
  }, other));
}